import { render, staticRenderFns } from "./OrticDatepickerControl.vue?vue&type=template&id=275aa6e3"
import script from "./OrticDatepickerControl.vue?vue&type=script&lang=js"
export * from "./OrticDatepickerControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports